import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { Separator } from "./ui/separator";
import { companyInfo, navLinks, services } from "../data/data";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-pc-primary texture-grain">
      {/* Top accent bar */}
      <div className="h-1 bg-pc-accent" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          {/* Company Info */}
          <div className="lg:col-span-4">
            <img
              src="/logo-white.svg"
              alt="Prayosha Construction"
              className="h-[36px] w-auto mb-6"
            />
            <p className="text-white/50 font-body text-sm leading-relaxed mb-6 max-w-xs">
              {companyInfo.description}
            </p>
            <div className="flex items-center gap-2">
              <span className="w-8 h-[2px] bg-pc-accent rounded-full" />
              <p className="text-pc-accent text-sm font-heading font-semibold">
                Est. {companyInfo.established}
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-heading font-semibold text-xs uppercase tracking-[0.2em] mb-6">
              Navigate
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/50 font-body text-sm hover:text-white hover:translate-x-1 transition-all duration-200 inline-flex items-center gap-1 group"
                  >
                    {link.label}
                    <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <h4 className="text-white font-heading font-semibold text-xs uppercase tracking-[0.2em] mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              {services.slice(0, 6).map((service) => (
                <li key={service.id}>
                  <Link
                    to="/services"
                    className="text-white/50 font-body text-sm hover:text-white transition-colors duration-200"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <h4 className="text-white font-heading font-semibold text-xs uppercase tracking-[0.2em] mb-6">
              Reach Us
            </h4>
            <div className="space-y-4">
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-start gap-3 text-white/50 text-sm hover:text-white transition-colors duration-200"
              >
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-pc-accent" />
                <span className="font-body">{companyInfo.phone}</span>
              </a>
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-start gap-3 text-white/50 text-sm hover:text-white transition-colors duration-200"
              >
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-pc-accent" />
                <span className="font-body">{companyInfo.email}</span>
              </a>
              <div className="flex items-start gap-3 text-white/50 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-pc-accent" />
                <span className="font-body">{companyInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-10 bg-white/10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 font-body text-xs tracking-wide">
            &copy; {currentYear} Prayosha Construction. All rights reserved.
          </p>
          <p className="text-white/30 font-body text-xs tracking-wide">
            Gujarat, India
          </p>
        </div>
      </div>
    </footer>
  );
};
